// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol, OnAfterCodeLoad, HasChangedInternallySymbol } from "@lg/shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => GoalSettingNotificationType.loadInternal(), entryList => {
        GoalSettingNotificationType.θentryList.set(entryList)
        GoalSettingNotificationType.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class GoalSettingNotificationType {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label"] as const,
        allPropertyNames: ["id", "label"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<GoalSettingNotificationType.Id | null>;
    static readonly Id = String;
    static ids: GoalSettingNotificationType.Id[] = [] as any;
    static idsAndDisplayValues: Record<GoalSettingNotificationType.Id, string> = {} as any;
    static θentryList = signal<GoalSettingNotificationType.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<GoalSettingNotificationType.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? GoalSettingNotificationType.getEntryMap()[id]?.label : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return GoalSettingNotificationType[BoInfoSymbol]
    }

    get __type(): 'Toolbox.GoalSettingNotificationType' {
        return 'Toolbox.GoalSettingNotificationType'
    }

    set __type(_) {
    }

    static get __type(): 'Toolbox.GoalSettingNotificationType' {
        return 'Toolbox.GoalSettingNotificationType'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): GoalSettingNotificationType.Id | null {
        return this.θid()
    }

    set id(id: GoalSettingNotificationType.Id | GoalSettingNotificationType | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !GoalSettingNotificationType.getEntry(id as GoalSettingNotificationType.Id)) throw new Error('Invalid id for type Toolbox.GoalSettingNotificationType: ' + id)
        this.θid.set(id as GoalSettingNotificationType.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): GoalSettingNotificationType.Id[] {
        return GoalSettingNotificationType.ids
    }

    get idsAndDisplayValues(): Record<GoalSettingNotificationType.Id, string> {
        return GoalSettingNotificationType.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[GoalSettingNotificationType.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get isGoalSettingStarted() {
        return this.id == 'goalSettingStarted'
    }

    static get GoalSettingStarted() {
        return new this('goalSettingStarted')
    }

    get isGoalSettingSubmitted() {
        return this.id == 'goalSettingSubmitted'
    }

    static get GoalSettingSubmitted() {
        return new this('goalSettingSubmitted')
    }

    get isGoalSettingApproved() {
        return this.id == 'goalSettingApproved'
    }

    static get GoalSettingApproved() {
        return new this('goalSettingApproved')
    }

    get isGoalSettingRejected() {
        return this.id == 'goalSettingRejected'
    }

    static get GoalSettingRejected() {
        return new this('goalSettingRejected')
    }

    get isSelfReviewStarted() {
        return this.id == 'selfReviewStarted'
    }

    static get SelfReviewStarted() {
        return new this('selfReviewStarted')
    }

    get isSelfReviewSubmitted() {
        return this.id == 'selfReviewSubmitted'
    }

    static get SelfReviewSubmitted() {
        return new this('selfReviewSubmitted')
    }

    get isManagerReviewReleased() {
        return this.id == 'managerReviewReleased'
    }

    static get ManagerReviewReleased() {
        return new this('managerReviewReleased')
    }

    constructor(idOrObject: GoalSettingNotificationType.Id | GoalSettingNotificationType | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): GoalSettingNotificationType.Entry[] {
        return This.GoalSettingNotificationType.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): GoalSettingNotificationType.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: GoalSettingNotificationType.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof GoalSettingNotificationType.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = GoalSettingNotificationType.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<GoalSettingNotificationType.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return LowgileDataUtil.createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new GoalSettingNotificationType(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: GoalSettingNotificationType.Id | GoalSettingNotificationType | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as GoalSettingNotificationType.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: GoalSettingNotificationType.Id | GoalSettingNotificationType) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<GoalSettingNotificationType.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Toolbox.GoalSettingNotificationType yet:', err.message)
            //throw err
        })
    }

    static $getSchema() {
        return z.string()
    }

    $getSchema() {
        return z.string()
    }

    setGoalSettingStarted() {
        this.id = 'goalSettingStarted'

    }

    setGoalSettingSubmitted() {
        this.id = 'goalSettingSubmitted'

    }

    setGoalSettingApproved() {
        this.id = 'goalSettingApproved'

    }

    setGoalSettingRejected() {
        this.id = 'goalSettingRejected'

    }

    setSelfReviewStarted() {
        this.id = 'selfReviewStarted'

    }

    setSelfReviewSubmitted() {
        this.id = 'selfReviewSubmitted'

    }

    setManagerReviewReleased() {
        this.id = 'managerReviewReleased'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "goalSettingStarted", label: "Goal setting started" }),
            Object.freeze({ id: "goalSettingSubmitted", label: "Goal setting submitted" }),
            Object.freeze({ id: "goalSettingApproved", label: "Goal setting approved" }),
            Object.freeze({ id: "goalSettingRejected", label: "Goal setting rejected" }),
            Object.freeze({ id: "selfReviewStarted", label: "Self review started" }),
            Object.freeze({ id: "selfReviewSubmitted", label: "Self review submitted" }),
            Object.freeze({ id: "managerReviewReleased", label: "Manager review released" })
        ] as GoalSettingNotificationType.Entry[]) as GoalSettingNotificationType.Entry[]
    }
}
jsonClass('Toolbox.GoalSettingNotificationType')(GoalSettingNotificationType)

export const GoalSettingNotificationTypeθId = String;

export type GoalSettingNotificationTypeθId = string;

export namespace GoalSettingNotificationType {
    export type Id = 'goalSettingStarted' | 'goalSettingSubmitted' | 'goalSettingApproved' | 'goalSettingRejected' | 'selfReviewStarted' | 'selfReviewSubmitted' | 'managerReviewReleased'

    export interface Entry {
        id: GoalSettingNotificationType.Id;
        label: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => GoalSettingNotificationType.load(true))
